import { useDispatch } from 'react-redux'
import { useHistory } from "react-router-dom";

import { addToCart, addMultipleToCart, addCTOToCart, launchCartFlyout } from '../utility/utility-actions';
import { getCTOLink } from '../core/src/etr-api-client/cto';

/**
 * @typedef {Object} AddToCartFunctions
 * @property {function(): promise} addCTOToCart - Adds a CTO preconfig to cart
 * @property {function(): promise} addToCart - Adds a STO product to cart
 * @property {function(): promise} addMultipleToCart - Add multiple STO products to cart
 * @property {function(): promise} goToCTOPage - Link to CTO page using react router
 * @property {function(): promise} launchCartFlyout - Launch cart flyout with last item added to cart displayed
 */

/**
 * Returns redux connected add to cart functions
 * @name useAddToCart
 * @returns {AddToCartFunctions}
 */
export default function useAddToCart() {
    const dispatch = useDispatch();
    const history = useHistory();

    return {
        addCTOToCart: (product, quantity, blockFlyout, followRedirect) => dispatch(addCTOToCart(product, quantity, blockFlyout, followRedirect)),
        addToCart: (product, quantity, blockFlyout, addOns, variant, baseProductSku, xsellType, metricParams) => dispatch(addToCart(product, quantity, blockFlyout, addOns, variant, baseProductSku, xsellType, metricParams)),
        addMultipleToCart: (products, quantity, blockFlyout, options, baseProductSku, xsellType) => dispatch(addMultipleToCart(products, quantity, blockFlyout, options, baseProductSku, xsellType)),
        goToCTOPage: (catEntryId, quantity, additionalParams, isV2 = true) => { history.push(getCTOLink(catEntryId,quantity, additionalParams, isV2)) },
        launchCartFlyout: () => dispatch(launchCartFlyout()),
    };
}